var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentPaypal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.38,4C22.18,2.59,20,2,17.22,2H9.14A1.16,1.16,0,0,0,8,3L4.63,24.31a.7.7,0,0,0,.69.81h5l1.26-7.95,0,.25a1.16,1.16,0,0,1,1.14-1H15c4.65,0,8.3-1.89,9.36-7.36,0-.16.06-.32.09-.47h0A5.2,5.2,0,0,0,23.38,4",
    fill: "#27346a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.46,7.88a1,1,0,0,1,.44-.1h6.34a13.6,13.6,0,0,1,2.09.15l.53.1c.25.06.5.13.74.21a4.65,4.65,0,0,1,.88.37A5.2,5.2,0,0,0,23.38,4C22.18,2.59,20,2,17.22,2H9.14A1.16,1.16,0,0,0,8,3L4.63,24.31a.69.69,0,0,0,.68.8h5L12.9,8.63a1,1,0,0,1,.56-.75Z",
    fill: "#27346a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.39,9.08c-1.06,5.47-4.71,7.36-9.36,7.36H12.66a1.16,1.16,0,0,0-1.14,1L10,27.3a.61.61,0,0,0,.6.7h4.2a1,1,0,0,0,1-.85l0-.22.8-5,0-.28a1,1,0,0,1,1-.85h.62c4.08,0,7.27-1.66,8.2-6.44.39-2,.19-3.67-.84-4.85a4.08,4.08,0,0,0-1.15-.88c0,.15-.05.31-.09.47Z",
    fill: "#2790c3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.36,8.16,22.86,8l-.53-.1a13.6,13.6,0,0,0-2.09-.15H13.9a.91.91,0,0,0-.43.1,1,1,0,0,0-.57.75l-1.34,8.54,0,.25a1.16,1.16,0,0,1,1.14-1H15c4.65,0,8.3-1.89,9.37-7.36,0-.16.05-.32.08-.47a4.65,4.65,0,0,0-.88-.37l-.24-.08",
    fill: "#1f264f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentPaypal);
export default __webpack_public_path__ + "static/media/payment-paypal.f02756c212cdc70e7fa6ea520406eb19.svg";
export { ForwardRef as ReactComponent };